import { DisplayInput } from '../DisplayInput';
import {
    withMask,
    formatCnpj,
    parseCpf,
    parseCnpj,
    formatCpf,
    formatCep,
    parseCep,
    formatTel,
    parseTel,
    formatCpfCnpj,
    parseCpfCnpj,
    formatSusep,
    parseSusep,
} from '../InputText';

export const DisplayInputCpf = withMask(DisplayInput, { format: formatCpf, parse: parseCpf });

export const DisplayInputCnpj = withMask(DisplayInput, { format: formatCnpj, parse: parseCnpj });

export const DisplayInputCep = withMask(DisplayInput, { format: formatCep, parse: parseCep });

export const DisplayInputTel = withMask(DisplayInput, { format: formatTel, parse: parseTel });

export const DisplayInputCpfCnpj = withMask(DisplayInput, {
    format: formatCpfCnpj,
    parse: parseCpfCnpj,
});

export const DisplayInputSusep = withMask(DisplayInput, { format: formatSusep, parse: parseSusep });
